<template>
<div class="chapter">
<div class="inner_page">
<p class="title">K is for KNIFEBALL</p>
<p class="sub-title">an alphabet of TERRIBLE advice</p>
<p class="by-line">by Avery Monsen and Jory John</p>
<p class="chronicle-books-logo"><img alt="chronicle books" src="images/chronicle-books.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02titlepage.vue?17a2eccb